/**
 * List of events used by participants filter widget
 *
 */
export const participantsFilter = {
  PARTICIPANTS_FILTER__FILTER_APPLIED: 'ParticipantsFilter.FilterApplied'
}
